<template>
    <div>
        <div
            class="container"
            v-if="
        this.$route.name != 'home' &&
        this.$route.name != 'checkout' &&
        this.$route.name != 'video' &&
        this.$route.name != 'CheckoutFinish'
      "
        >
            <div class="home-curso-list" v-if="cursosFooter.length > 0">
                <br/>
                <h3 class="home-curso-list-title">TAMBIÉN TE PUEDE INTERESAR</h3>
                <curso-list
                    :cursos="cursosFooter"
                    :columnas="4"
                    carouselactive="1"
                    @cursoClick="verCurso"
                />
            </div>
        </div>

        <footer
            class="site-footer"
            v-if="verFooter && typeof this.$route.query.operador === 'undefined'"
        >
            <div class="container">
                <div class="site-footer-top">
                    <div class="row">
                        <div class="col-md-6 col-lg-5">
                            <div class="row">
                                <div class="col-md-12">
                                    <router-link to="/" class="top-bar-logo gtm_home">
                                        <img
                                            v-if="portal.id != 0"
                                            :src="portal.foto_principal.replace('http:', 'https:')"
                                            class="site-footer-logo"
                                        />
                                    </router-link>
                                    <br/><br/>
                                    <div class="suscribete_a_nuestras_noticias">
                                        Suscribete a nuestras noticias
                                    </div>
                                    <br/>
                                    <form @submit.prevent="suscribir">
                                        <div class="input-group">
                                            <input
                                                type="email"
                                                required
                                                class="form-control boletin_suscripcion"
                                                v-model="boletin_suscripcion"
                                                placeholder="usuario@correo.cl"
                                            />
                                            <div class="input-group-prepend">
                                                <button
                                                    class="input-group-text rectangle_boletin_suscripcion"
                                                    style="adding-left: 10px; padding-top: 0px"
                                                >
                                                    &gt;
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                    <div class="contacto_topclass_cl">
                                        <span class="ocultar-movil">
                                          General Holley 133, Providencia, Santiago<br/>
                                            Código Postal: 7510099<br/>
                                            <a href="mailto:contacto@topclass.cl">contacto@topclass.cl</a>
                                        </span>
                                    </div>
                                    <a href="https://blog.topclass.cl/"
                                       class="btn btn-banner btn-banner-blue text-white"
                                       style="margin-left:0px; margin-top: 5px; margin-bottom: 5px; margin-right: 5px">
                                        BLOG
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-7">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="topclass_list_footer" @click="acordion_paginas">
                                        <div class="row">
                                            <div
                                                class="col col-1 mostrar-movil"
                                                style="text-align: right"
                                            >
                        <span
                            v-if="this.isAcordPagina"
                            style="font-size: 22px; color: #24ccc0"
                        >+</span
                        >
                                                <span v-else style="font-size: 22px; color: #24ccc0"
                                                >-</span
                                                >
                                            </div>
                                            <div class="col col-md-6 alinacion-header-footer">
                                                TOPCLASS
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="site-footer-pages-wrapper"
                                        :class="{
                      'ocultar-movil': this.isAcordPagina,
                    }"
                                    >
                                        <ul class="site-footer-menu">
                                            <li v-for="page in pages" :key="page.id">
                                                <a
                                                    :href="'/pagina/' + page.guid"
                                                    class="top-bar-link"
                                                    style="text-transform: none"
                                                >
                                                    {{ page.titulo }}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="https://linktr.ee/TopClassCl"
                                                    target="_blank"
                                                    class="top-bar-link"
                                                    style="text-transform: none"
                                                >
                                                    Preguntas Frecuente
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="https://topclass.zendesk.com/hc/es-419"
                                                    target="_blank"
                                                    class="top-bar-link"
                                                    style="text-transform: none"
                                                >
                                                    Centro de Ayuda
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="https://topclass.cl"
                                                    target="_blank"
                                                    class="top-bar-link"
                                                    style="text-transform: none"
                                                >
                                                    Inicio
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="topclass_list_footer" @click="acordion_autor">
                                        <div class="row">
                                            <div
                                                class="col col-1 mostrar-movil"
                                                style="text-align: right"
                                            >
                                                >>>>>>> dev
                                                <span
                                                    v-if="this.isAcordAutor"
                                                    style="font-size: 22px; color: #24ccc0"
                                                >+</span
                                                >
                                                <span v-else style="font-size: 22px; color: #24ccc0"
                                                >-</span
                                                >
                                            </div>
                                            <div class="col col-md-6 alinacion-header-footer">
                                                INSTRUCTORES
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="site-footer-pages-wrapper"
                                        :class="{
                      'ocultar-movil': this.isAcordAutor,
                    }"
                                    >
                                        <ul class="site-footer-menu">
                                            <li v-for="autor in autores" :key="autor.id">
                                                <a
                                                    :href="'/curso/' + autor.guid"
                                                    class="top-bar-link"
                                                    style="text-transform: none"
                                                >
                                                    {{ autor.autor }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="topclass_list_footer" @click="acordion_curso">
                                        <div class="row">
                                            <div
                                                class="col col-1 mostrar-movil"
                                                style="text-align: right"
                                            >
                        <span
                            v-if="this.isAcordCurso"
                            style="font-size: 22px; color: #24ccc0"
                        >+</span
                        >
                                                <span v-else style="font-size: 22px; color: #24ccc0"
                                                >-</span
                                                >
                                            </div>
                                            <div class="col col-md-6 alinacion-header-footer">
                                                CURSOS
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="site-footer-pages-wrapper"
                                        :class="{
                      'ocultar-movil': this.isAcordCurso,
                    }"
                                    >
                                        <ul class="site-footer-menu">
                                            <li v-for="cat in categorias" :key="cat.id">
                                                <a
                                                    :href="'/curso/' + cat.guid"
                                                    class="top-bar-link"
                                                    style="text-transform: none"
                                                >
                                                    {{ cat.categoria }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 col-lg-5">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="site-footer-social-wrapper">
                                        <ul class="site-footer-social">
                                            <li>
                                                <a
                                                    href="#"
                                                    target="_blank"
                                                    rel="external noopener"
                                                    title="Top-5-Finalistas-eCommerce-Award"
                                                >
                                                    <img
                                                        style="width: 100px"
                                                        src="https://res.cloudinary.com/dmx3pf3os/image/upload/fl_lossy/q_auto:low/v1555337226/Top-5-Finalistas-eCommerce-Award.png"
                                                    />
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="#"
                                                    target="_blank"
                                                    rel="external noopener"
                                                    title=""
                                                >
                                                    <img
                                                        src="https://res.cloudinary.com/dmx3pf3os/image/upload/fl_lossy/q_auto:low/v1549463792/image_1.png"
                                                    />
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    
                                                    href="https://www.facebook.com/topclasslatam/"
                                                    target="_blank"
                                                    rel="external noopener"
                                                    title="Facebook"
                                                >
                                                    <img
                                                        src="https://res.cloudinary.com/dmx3pf3os/image/upload/fl_lossy/q_auto:low/v1549463793/facebook_logo_button.png"
                                                    />
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="https://instagram.com/topclasslatam"
                                                    target="_blank"
                                                    rel="external noopener"
                                                    title="Instagram"
                                                >
                                                    <img
                                                        src="https://res.cloudinary.com/dmx3pf3os/image/upload/fl_lossy/q_auto:low/v1549463792/instagram_logo.png"
                                                    />
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="https://www.youtube.com/channel/UCmoyxXfeRyKA636F5oOpxnw"
                                                    target="_blank"
                                                    rel="external noopener"
                                                    title="Youtube"
                                                >
                                                    <img
                                                        src="https://res.cloudinary.com/dmx3pf3os/image/upload/fl_lossy/q_auto:low/v1549463792/youtube.png"
                                                    />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-7 ocultar-movil">
                            <div class="aprendeconlosmejores">
                                <span class="color-aqua">Lo que quieres aprender, con quien sueñas aprenderlo</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="site-footer-bottom"
                    :style="{
            'margin-bottom': NoAvailable ? '17%' : '0',
          }"
                >
                    <div class="row">
                        <div class="col-sm-7 ocultar-movil">
                            ¿Necesitas ayuda?
                            <a
                                style="text-transform: uppercase"
                                class="color-aqua"
                                target="_blank"
                                href="https://topclass.zendesk.com/hc/es-419"
                            >Centro de Ayuda</a
                            >
                        </div>
                        <div class="col-sm-5 color-aqua">
                            <div
                                class="___copyright_celcom_2019_todos_los_derechos_reservados_"
                            >
                                <span class="char">© </span> Copyright Celcom 2020 Todos los
                                derechos reservados
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

        <b-modal
            v-model="isPortalSuscribirModalVisible"
            :busy="true"
            centered
            hide-footer
            title="Notificacion"
        >
            <div
                class="text-center"
                :class="{
          'color-red': !colorMensaje,
          'color-green': colorMensaje,
        }"
            >
                <div class="text-center alert-text-box">
                    <p class="color-gray" v-html="mensajeAplicado"></p>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import CursoList from "../components/CursoList";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import {getProductoDeCategoriaFooter} from "../utilities/data";

export default {
    props: ["NoAvailable", "verFooter"],
    components: {
        CursoList,
        bModal,
    },
    data() {
        return {
            isAcordPagina: false,
            isAcordAutor: true,
            isAcordCurso: true,
            boletin_suscripcion: "",
            isPortalSuscribirModalVisible: false,
            mensajeAplicado: "",
            colorMensaje: false,
        };
    },
    computed: {
        autores() {
            let autores = [];
            this.portal.categorias.forEach((cat) => {
                autores.push({id: cat.id, autor: cat.autor, guid: cat.guid});
            });

            return autores;
        },
        categorias() {
            let categorias = [];
            this.portal.categorias.forEach((cat) => {
                categorias.push({
                    id: cat.id,
                    categoria: cat.categoria,
                    guid: cat.guid,
                });
            });

            return categorias;
        },
        pages() {
            return this.portal.portales_paginas.filter(
                (pagina) => pagina.destacado_footer == 1
            );
        },
        cursosFooter() {
            return this.portal.categorias
                .map((categoria) => {
                    return {
                        categoria,
                        producto: getProductoDeCategoriaFooter(this.portal, categoria.id),
                    };
                })
                .filter(
                    (producto) =>
                        producto.categoria !== false && producto.categoria.destacado_footer
                );
        },
        ...mapState(["portal"]),
    },
    mounted() {
        let zendeskScript = document.createElement("script");
        zendeskScript.setAttribute("id", "ze-snippet");
        zendeskScript.setAttribute(
            "src",
            "https://static.zdassets.com/ekr/snippet.js?key=0c4ad394-618d-4f94-90b3-262c92c4661d"
        );
        document.head.appendChild(zendeskScript);
    },
    methods: {
        suscribir() {
            if (this.boletin_suscripcion != "") {
                this.isPortalSuscribirModalVisible = true;
                this.colorMensaje = true;
                this.mensajeAplicado = "procesando ...";
                this.$api
                    .event_klaviyo_suscribir({
                        email_suscribir: this.boletin_suscripcion,
                    })
                    .then((response) => {
                        if (response.data.response == "200") {
                            this.isPortalSuscribirModalVisible = true;
                            this.colorMensaje = true;
                            this.mensajeAplicado = "Suscripcion realizada con exito";
                            this.boletin_suscripcion = "";
                        } else {
                            this.isPortalSuscribirModalVisible = true;
                            this.colorMensaje = false;
                            this.mensajeAplicado = "Error al Suscribrir email";
                        }
                    });
            } else {
                alert("ingresar email");
            }
        },

        acordion_paginas() {
            if (this.isAcordPagina) {
                this.isAcordPagina = false;
            } else {
                this.isAcordPagina = true;
            }
        },
        acordion_autor() {
            if (this.isAcordAutor) {
                this.isAcordAutor = false;
            } else {
                this.isAcordAutor = true;
            }
        },
        acordion_curso() {
            if (this.isAcordCurso) {
                this.isAcordCurso = false;
            } else {
                this.isAcordCurso = true;
            }
        },
        verCurso(categoria, producto) {
            if (this.$route.name != "curso") {
                this.$router.push({
                    name: "curso",
                    params: {
                        guid: categoria.guid,
                    },
                });
            } else {
                this.$router.replace({
                    path: "/curso/" + categoria.guid,
                });
                this.$router.go({
                    path: "/curso/" + categoria.guid,
                    force: true,
                });
            }
        },
    },
};
</script>
